"use server";

import { Product, SearchResults } from "../types/search";
import { serverRepo } from "../apis/server_repo";
import { ClientConfig } from "../types/client";
import { getRequestEvent } from "solid-js/web";
import { V4HomeResponse } from "~/data/v4_homepage";
import { Mode } from "~/types";
import { redirect } from "@solidjs/router";

export type WebStoreRouteData = {
  brands: Product[];
  isLoggedIn: boolean;
  v4HomePage: V4HomeResponse | null;
  clientConfig: ClientConfig | undefined;
  clientId: string | undefined;
  mode: Mode;
};

export const getStoreRouteData = async (): Promise<WebStoreRouteData> => {
  let v4HomePagePromise: Promise<V4HomeResponse | null> | null = null;
  const requestEvent = getRequestEvent();
  const sid = requestEvent?.locals.sid;
  const mode = requestEvent?.locals.mode ?? "hubble";
  let clientConfigPromise: Promise<ClientConfig> | undefined;
  let clientId = requestEvent?.locals.clientId;

  if (mode === "squid") {
    throw redirect("/login");
  }

  const url = new URL(requestEvent?.request.url ?? "");
  if (mode === "rnr" && !sid && url.pathname !== "/login") {
    throw redirect("/login");
  }

  if (
    url.hostname === "shelcal.myhubble.money" ||
    url.hostname === "shelcal.dev.myhubble.money"
  ) {
    throw redirect("/tp_cpn");
  }

  if (mode === "rnr" && clientId) {
    clientConfigPromise = serverRepo.getClientConfig(clientId);
  }

  if (sid) {
    v4HomePagePromise = serverRepo.fetchV4Home();
  }
  const searchBrands$Promise = serverRepo.getProductSearch({
    query: "",
    pagination: { pageNo: 0, limit: 30 },
  });

  const [searchBrandsResponse, v4HomePageResponse, clientConfigResponse] =
    await Promise.all([
      searchBrands$Promise,
      v4HomePagePromise,
      clientConfigPromise,
    ]);

  const brands = getActiveBrandsFromSearchResponse(searchBrandsResponse);

  return {
    brands,
    isLoggedIn: v4HomePageResponse !== null,
    v4HomePage: v4HomePageResponse,
    clientConfig: clientConfigResponse,
    clientId,
    mode,
  };
};

function getActiveBrandsFromSearchResponse(
  searchBrandsResponse: SearchResults
) {
  const brands: Product[] = [];
  searchBrandsResponse.data.forEach((section) => {
    section.products.forEach((product) => {
      if (product.voucherProduct.status === "ACTIVE") {
        brands.push(product);
      }
    });
  });
  return brands;
}
